const lang = window.tigConfig?.shopSettings?.language || 'en';

const errorMessages = {
  cartAddFailed: {
    ja: 'カートに追加できませんでした',
    en: 'Failed to add to cart'
  }
};

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

function updateHeaderTotal() {
    return fetch(`${window.theme.routes.cart}.js`).then((response)=>{
      return response.json().then((data) => {
        document.dispatchEvent(new CustomEvent('theme:cart:change', {
            detail: {
                cart: data
            },
            bubbles: true
        }));
      });
    }).catch((e)=>{
        console.error(e);
    });
}

function reloadCart() {
    document.dispatchEvent(new CustomEvent('theme:cart:reload', {
        bubbles: true
    }));
}

function addtocartHandler(event) {
    // ここで実際にショッピングカートに商品を追加して更新する処理を実装する
    console.log('addtocart event', event);

    const productId = event.productId;
    const variantId = event.variantId.split('/').pop();
    const quantity = event.quantity;
    console.log([variantId, quantity]);

    const cart = document.querySelector('tig-cart-notification');

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = new FormData(this.form);
    if (cart) {
        formData.append(
            'sections',
            cart.getSectionsToRender().map((section) => section.id),
        );
        formData.append('sections_url', window.location.pathname);
        cart.setActiveElement(document.activeElement);
    }
    formData.append('form_type', 'product');
    formData.append('product-id', productId);
    formData.append('id', variantId);
    formData.append('quantity', quantity);
    config.body = formData;

    const cartAddUrl = (window.routes && window.routes.cart_add_url) || '/cart/add.js';
    fetch(cartAddUrl, config)
        .then((response) => {
            return response.json().then((data) => {
                if (!response.ok) {
                    // エラーメッセージを表示する準備
                    throw new Error(data.message || errorMessages.cartAddFailed[lang]);
                }
                return data;
            });
        })
        .then((response) => {
            console.log(`cart/add response`, response);

            cart.renderContents(response);
            cart.open();

            // PXG独自　カート表示更新
            reloadCart();
            updateHeaderTotal();

        })
        .catch((error) => {
            console.error('Error:', error);
            alert(error.message);
        });
}

/**
 * Tig独自カート表示実装
 */
class TigCartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('tig-cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(response) {
    const product_title = response.product_title;
    const image = response.image;
    const aspect_ratio = response.featured_image.aspect_ratio;
    const options = response.options_with_values;

    this.querySelector('.tig-cart-notification-product__name').innerText = product_title;
    this.querySelector('.tig-cart-notification-product__image img').src = image;
    this.querySelector('.tig-cart-notification-product__image img').alt = product_title;
    this.querySelector('.tig-product-option-list').innerHTML = '';
    if (options && Array.isArray(options)) {
      options.forEach((option) => {
        // <div class="product-option">
        //   <dt>Color:</dt>
        //   <dd>NAVY</dd>
        // </div>
        const productOption = document.createElement('div');
        const dt = document.createElement('dt');
        const dd = document.createElement('dd');
        productOption.classList.add('tig-product-option');
        dt.innerText = option.name + ': ';
        dd.innerText = option.value;
        productOption.appendChild(dt);
        productOption.appendChild(dd);
        this.querySelector('.tig-product-option-list').appendChild(productOption);
      });
    }

    if (this.header) this.header.reveal();
  }

  getSectionsToRender() {
    return [
      {
        id: 'tig-cart-notification-product',
        selector: `[id="tig-cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'tig-cart-notification-button',
      },
      {
        id: 'tig-cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('tig-cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('tig-cart-notification', TigCartNotification);

